module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header_3-1a2b41ca4eb2ae00da9e97a1c5f5b1f3.svg";